import About from '@/components/About'
import AppPromo from '@/components/AppPromo'
import Contact from '@/components/Contact'
import EbookPreview from '@/components/EbookPreview'
import Footer from '@/components/Footer'
import Hero from '@/components/Hero'
import LinksList from '@/components/LinksList'
import Navbar from '@/components/Navbar'
import Partners from '@/components/Partners'
import { useLanguage } from '@/context/LanguageContext'
import { useHead } from '@unhead/react'
import { Toaster } from 'react-hot-toast'

function Home() {
  const { t, lang } = useLanguage()

  useHead({
    htmlAttrs: { lang },
    title: t.meta.title,
    meta: [
      { name: 'description', content: t.meta.description },
      { property: 'og:title', content: t.meta.title },
      { property: 'og:description', content: t.meta.description },
      { property: 'og:type', content: 'website' },
      { name: 'twitter:card', content: 'summary_large_image' },
    ],
  })

  return (
    <div className="min-h-screen bg-[#2b1c12]">
      <Toaster position="top-center" />
      <Navbar />
      <AppPromo />
      <Hero />
      <LinksList />
      <EbookPreview />
      <About />
      <Partners />
      <Contact />
      <Footer />
    </div>
  )
}

export default Home
